import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    fontSize: 12,
    fontStyle: "bold",
  },
  description: {
    width: "85%",
    textAlign: "right",
    borderRightWidth: 1,
    paddingRight: 8,
  },
  total: {
    width: "15%",
    textAlign: "right",
    paddingRight: 8,
  },
});

const InvoiceTableDueFooter = ({ previousDue }) => {
  return (
    <View style={styles.row}>
      <Text style={styles.description}>Previous Due</Text>
      <Text style={styles.total}>{previousDue}</Text>
    </View>
  );
};

export default InvoiceTableDueFooter;
